module.exports = __webpack_public_path__ + "img/imgImgHome12.e789fe5d.svg";